import { createRoot } from 'react-dom/client';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import createPersistStore from "./state/configureStore";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import he from "./translation/he.json";
import ar from "./translation/ar.json";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import { StyledEngineProvider } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const { store, persistor } = createPersistStore();

const getLang = (): string => {
  let lng = localStorage.getItem("lang");
  if (lng !== "ar" || typeof lng !== "string") {
    lng = "he"
    localStorage.setItem("lang", lng)
  }
  return lng && typeof lng === "string" ? lng : "he";
};

const lang = getLang();
i18next.init({
  interpolation: { escapeValue: false },
  lng: lang,
  resources: {
    he: { common: he },
    ar: { common: ar },
  }, // React already does escaping
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#0250C1',
    },
    secondary: {
      main: '#0250C1',
    },
  },
  typography: {
    fontFamily: 'RagSans',
  },
  //direction: "rtl"
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <I18nextProvider i18n={i18next}>
    {/* <ThemeProvider theme={theme}> */}
      <StyledEngineProvider injectFirst>
        <Provider store={store}>
          {/* TODP -AA check type error */}
          {/* @ts-ignore:next-line */}
          <PersistGate loading={null} persistor={persistor}>
            <App  />
          </PersistGate>
        </Provider>
      </StyledEngineProvider>
    {/* </ThemeProvider> */}
  </I18nextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
